import { createSlice } from "@reduxjs/toolkit";
import moment from 'moment';

const initialState = {
    defaultEntity: {
        id: 0,
        codigo: "",
        descripcion: "",
        idServicio: 0,
        codigoServicio: "",
        servicio: "",
        idFilial: 0,
        codigoFilial: "",
        filial: "",
        idTipo: 0,
        tipo: "",
        idModalidad: 0,
        modalidad: "",
        sesionesMes: 0,
        minutosSesion: 0,
        monto: 0.00,
        idEstado: 2,
        estado: "Activo",
        observaciones: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    entity: {
        id: 0,
        codigo: "",
        descripcion: "",
        idServicio: 0,
        codigoServicio: "",
        servicio: "",
        idFilial: 0,
        codigoFilial: "",
        filial: "",
        idTipo: 0,
        tipo: "",
        idModalidad: 0,
        modalidad: "",
        sesionesMes: 0,
        minutosSesion: 0,
        monto: 0.00,
        idEstado: 2,
        estado: "Activo",
        observaciones: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    },
    listServicios: [{id: 0, descripcion: ""}],
    listFiliales: [{id: 0, descripcion: ""}],
    listTipos: [{id: 0, descripcion: ""}],
    listModalidades: [{id: 0, descripcion: ""}],
    listEstados: [{id: 0, descripcion: ""}],
    validationActive: {
        idServicio: false,
        idFilial: false,
        idTipo: false,
        idModalidad: false,
    },
    validationMessage: [],
  }
  
  export const invoiceItemSlice = createSlice({
    name: "invoiceItem",
    initialState,
    reducers: {
      setEntity: (state, action) => {
        state.entity = action.payload;
      },
      setData: (state, action) => {
        var { name, value } = action.payload;
  
        if (name.startsWith("id")) value = parseInt(value)
        if (name == "minutosSesion" || name == "sesionesMes") value = parseInt(value)
        if (name == "monto") value = parseFloat(value)
        
        state.entity[name] = value
        state.validationActive[name] = true
      },
      setValidationMessage: (state, action) => {
        state.validationMessage = action.payload;
      },
      activeValidations: (state, action) => {
        Object.keys(state.validationActive).forEach(function (key) {
          state.validationActive[key] = true;
        })
      },
      setListServicios: (state, action) => {
        state.listServicios = action.payload;
      },
      setListFiliales: (state, action) => {
        state.listFiliales = action.payload;
      },
      setListTipos: (state, action) => {
        state.listTipos = action.payload;
      },
      setListModalidades: (state, action) => {
        state.listModalidades = action.payload;
      },
      setListEstados: (state, action) => {
        state.listEstados = action.payload;
      },
    },
  });
  
  export const { setEntity, setData, setValidationMessage, activeValidations
    , setListServicios, setListFiliales, setListTipos, setListModalidades, setListEstados } = invoiceItemSlice.actions;
  export default invoiceItemSlice.reducer;
  